// extracted by mini-css-extract-plugin
export default {"spinner":"ProductPage_spinner__Mbk4y","rotation":"ProductPage_rotation__mbhnk"};